import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { Trans } from 'react-i18next'
import { t } from 'i18next'
import { BaseDialogProps } from './BaseDialogProps'
import ConfirmButton from '../Button/ConfirmButton'

type DeleteProjectDialogProps = BaseDialogProps & {
  projectName: string | undefined
  handleDelete: () => void
}

const DeleteProjectDialog = ({ open, onClose, projectName, handleDelete }: DeleteProjectDialogProps) => {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      PaperProps={{
        elevation: 2,
        sx: {
          paddingLeft: 1,
          paddingRight: 2,
          paddingTop: 1,
          paddingBottom: 2,
        },
      }}
    >
      <DialogTitle color="text.highEmphasis">{t('page.projects.dialog.delete.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans i18nKey="page.projects.dialog.delete.content" values={{ name: projectName }} />
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ gap: 2 }}>
        <Button size="small" onClick={onClose}>{t('page.adminsPage.dialog.return')}</Button>
        <ConfirmButton text={t('page.projects.dialog.delete.confirm')} onClick={handleDelete}/>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteProjectDialog
